import { Link, Typography } from "@mui/material";
import { useTranslate } from "react-admin";
import { Link as RouterLink } from "react-router-dom";

import { CrmObject } from "../generated/graphql";
import { crmRecordPath } from "../lib/crm";

// The Salesforce account a facility is linked to, as a link to its CRM page.
export const OrganizationAccountLink = ({
  salesforceAccountId,
  salesforceAccountName,
}: {
  salesforceAccountId: string | null;
  salesforceAccountName: string | null;
}) => {
  const translate = useTranslate();
  if (!salesforceAccountId)
    return (
      <Typography component="span" variant="body2" color="text.secondary">
        {translate("customerServiceOrganizations.account.none")}
      </Typography>
    );
  if (!salesforceAccountName)
    return (
      <Typography component="span" variant="body2" color="text.secondary">
        {translate("customerServiceOrganizations.account.notInCrm", { id: salesforceAccountId })}
      </Typography>
    );
  return (
    <Link
      component={RouterLink}
      to={crmRecordPath(CrmObject.Account, salesforceAccountId)}
      // The link sits in clickable list rows.
      onClick={event => event.stopPropagation()}
    >
      {salesforceAccountName}
    </Link>
  );
};
